import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TiTick } from "react-icons/ti";
import "./features.css";

const Features = () => {
  return (
    <Container className="feature p-5" fluid id="features">
      <h1 className="text-center text-decoration-underline my-5 display-2 font-weight-bold">
        Features
      </h1>
      <Row>
        <Col md={6} className="d-flex justify-content-center py-5 ">
          <span className="feature__icon">
            <TiTick />
          </span>
          <div className="feature__detail">
            <h1 className="feature__detail-title">Merge PDF</h1>
            <p className="feature__detail-desc w-75">
              PDF merger allows you to quickly combine multiple PDF files into
              one single PDF document.
            </p>
          </div>
        </Col>
        <Col md={6} className="d-flex justify-content-center my-5">
          <span className="feature__icon">
            <TiTick />
          </span>
          <div className="feature__detail">
            <h1 className="feature__detail-title">Compress PDF</h1>
            <p className="feature__detail-desc w-75">
              Upload your file by either drag and drop or choose from the upload
              option, and wait for the compression to complete and saved to the
              document folder. It's that simple
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="d-flex justify-content-center my-5">
          <span className="feature__icon">
            <TiTick />
          </span>
          <div className="feature__detail">
            <h1 className="feature__detail-title">Split PDF</h1>
            <p className="feature__detail-desc w-75">
              Instantly divide your PDF into individual one-pager, or extract
              specific pages to form a new PDF document.
            </p>
          </div>
        </Col>
        <Col md={6} className="d-flex justify-content-center my-5">
          <span className="feature__icon">
            <TiTick />
          </span>
          <div className="feature__detail">
            <h1 className="feature__detail-title">
              Conversion from JPG to PDF and vice versa
            </h1>
            <p className="feature__detail-desc w-75">
              You can drag and drop your JPG/PDF image into the toolbox above to
              quickly transform it into PDF/JPG document
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Features;
